import type React from 'react';

export interface ConfidencePillProps {
  value: number | null;
}

export function ConfidencePill({ value }: ConfidencePillProps): React.JSX.Element {
  if (value == null)
    return <span className="confidence-pill confidence-pill--na">determinística</span>;
  const tone = value >= 0.85 ? 'high' : value >= 0.65 ? 'medium' : 'low';
  const label = tone === 'high' ? 'alta' : tone === 'medium' ? 'média' : 'baixa';
  return (
    <span className={`confidence-pill confidence-pill--${tone}`}>
      conf. <b>{value.toFixed(2)}</b> ({label})
    </span>
  );
}
